// Keep this aligned with backend-fastapi/app/common/constants.py.
export const DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 30, 50] as const;
